export const AUDIENCE = 'AUDIENCE';
export const TALENT_URL = 'TALENT_URL';
export const PC_URL = 'PC_URL';
export const CASTING_URL = 'CASTING_URL';
export const REPS_URL = 'REPS_URL';
export const NODE_ENV = 'NODE_ENV';
export const API_URL = 'API_URL';
export const ONBOARDING_URL = 'ONBOARDING_URL';
